export class SearchBarController implements ng.IController {
    isSearchOpen: boolean;
    searchTerm: string;

    static $inject: string[] = ['$timeout', '$scope'];

    constructor(private $timeout: ng.ITimeoutService, private $scope: ng.IScope) {
    }

    $onInit() { }

    get hasSearchTerm(): boolean {
        return this.searchTerm
            && this.searchTerm !== '';
    }

    clearSearchTerm(): void {
        this.searchTerm = '';
    }

    showSearch(): void {
        this.isSearchOpen = true;
        if (!this.isiDevice()) {
            this.$timeout(() => {
                document.getElementById('txtSearchBar').focus();
            }, 250);
        };

    }

    hideSearch(): void {
        this.isSearchOpen = false;
        this.clearSearchTerm();
        this.$timeout(() => {
            document.getElementById('txtSearchBar').blur();
        });
    }

    private isiDevice() {
        return (
            (navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPad") !== -1)
        );
    }

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/searchBar/controllers/searchBarController.ts
 **/